<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-6">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control form-control-sm"
          placeholder="Search by name or company..."
        />
      </div>
      <div class="col-md-6 text-right">
        <button class="e-btn e-btn-green e-text-white pr-3 mt-2 float-right" @click="openCreateModal">
          <font-awesome-icon icon="plus-square" style="width: 25px" />
          <small class="font-weight-bold text-uppercase">Add Inspector</small>
        </button>
      </div>
    </div>
    <!-- Pagination Controls -->
    <div class="row mt-3">
      <div class="col-md-6">
        <label>
          Show
          <select v-model="perPage" class="form-control form-control-sm d-inline-block w-auto ml-2">
            <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
          </select>
          entries
        </label>
      </div>
      <div class="col-md-6 text-right">
        <nav>
          <ul class="pagination pagination-sm justify-content-end mb-0">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="currentPage--" :disabled="currentPage === 1">
                Previous
              </button>
            </li>

            <li
              v-for="page in totalPages"
              :key="page"
              class="page-item"
              :class="{ active: currentPage === page }"
            >
              <button class="page-link" @click="currentPage = page">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button
                class="page-link"
                @click="currentPage++"
                :disabled="currentPage === totalPages"
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
          <table class="table table-bordered table-sm table-hover">
            <thead>
            <tr>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">#</th>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Lastname</th>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Firstname</th>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Middle Initial</th>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Company</th>
              <th class="text-center align-middle text-uppercase font-weight-bold" scope="col">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading">
              <td colspan="7" class="text-center text-muted h6 p-3 text-uppercase font-weight-bold">
                Loading, Please wait.
              </td>
            </tr>
            <tr v-if="paginatedInspectors.length === 0 && !loading">
              <td colspan="7" class="text-center text-muted h6 p-3 text-uppercase font-weight-bold">
                No results found
              </td>
            </tr>

            <tr v-for="(data, index) in paginatedInspectors" :key="data.id">
              <td class="text-center align-middle">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </td>
              <td class="text-center align-middle text-uppercase">{{ data.last_name }}</td>
              <td class="text-center align-middle text-uppercase">{{ data.first_name }}</td>
              <td class="text-center align-middle text-uppercase">{{ data.middle_name }}</td>
              <td class="text-center align-middle text-uppercase">{{ data.company?.name }}</td>
              <td class="text-center">
                <div class="btn-group dropleft">
                  <button class="mr-2 btn btn-sm btn-secondary force-white-all" data-toggle="dropdown" >
                    <font-awesome-icon icon="cogs" />
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item text-secondary font-weight-bolder" v-if="!data.deleted_at" @click="openEditModal(data)">
                      <font-awesome-icon icon="pen" /> &nbsp;Update
                    </button>
                    <button class="dropdown-item text-danger font-weight-bolder" v-if="!data.deleted_at" @click="openDeleteModal(data.id)">
                      <font-awesome-icon icon="trash" class="force-danger-all" />  &nbsp;Delete
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

      </div>
    </div>


    <div class="row mt-2">
      <div class="col-sm-12 text-right">
        <small class="text-muted">
          Showing
          <strong>{{ (currentPage - 1) * perPage + 1 }}</strong>
          to
          <strong>{{ Math.min(currentPage * perPage, filteredInspectors.length) }}</strong>
          of
          <strong>{{ filteredInspectors.length }}</strong>
          entries
        </small>
      </div>
    </div>

    <!-- Create Modal -->
    <div
      v-if="showCreateModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="createInspector">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Add Inspector</h5>
              <button type="button" class="close" @click="cancelCreateModal()">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label class="">First Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.first_name" class="form-control form-control-sm" onkeydown="return /[a-zA-Z  -]/i.test(event.key)"/>
              </div>
              <div class="form-group">
                <label class="">Last Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.last_name" class="form-control form-control-sm" onkeydown="return /[a-zA-Z  -]/i.test(event.key)"/>
              </div>
              <div class="form-group">
                <label class="">Middle Name <small class="font-weight-bold" style="font-style: italic;">(optional)</small></label>
                <input v-model="form.middle_name" class="form-control form-control-sm" onkeydown="return /[a-zA-Z  -]/i.test(event.key)"/>
              </div>
              <div class="form-group">
                <label class="">Extension <small class="font-weight-bold" style="font-style: italic;">(optional)</small></label>
                <input v-model="form.extension" class="form-control form-control-sm" />
              </div>
              <div class="form-group">
                <label class="">Company <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <select
                  v-model="form.inspector_company_id"
                  class="form-control form-control-sm"
                >
                  <option disabled :value="null">-- Select Company --</option>
                  <option v-for="company in companies" :key="company.id" :value="company.id">
                    {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      v-if="showEditModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="updateInspector">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Edit Inspector</h5>
              <button type="button" class="close" @click="cancelUpdateModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>First Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.first_name" class="form-control form-control-sm" />
              </div>
              <div class="form-group">
                <label>Last Name <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <input v-model="form.last_name" class="form-control form-control-sm" />
              </div>
              <div class="form-group">
                <label>Middle Name <small class="font-weight-bold" style="font-style: italic;">(optional)</small></label>
                <input v-model="form.middle_name" class="form-control form-control-sm" />
              </div>
              <div class="form-group">
                <label>Extension <small class="font-weight-bold" style="font-style: italic;">(optional)</small></label>
                <input v-model="form.extension" class="form-control form-control-sm" />
              </div>
              <div class="form-group">
                <label>Company <small class="text-danger font-weight-bold" style="font-style: italic;">(required)</small></label>
                <select
                  v-model="form.inspector_company_id"
                  class="form-control form-control-sm"
                >
                  <option disabled value="">-- Select Company --</option>
                  <option v-for="company in companies" :key="company.id" :value="company.id">
                    {{ company.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Delete Modal -->
    <div
      v-if="showDeleteModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="deleteInspector">
            <div class="modal-header">
              <h5 class="modal-title text-uppercase font-weight-bold">Delete Inspector</h5>
              <button type="button" class="close" @click="cancelDeleteModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <h5 class="text-uppercase font-weight-bold">Are you sure you want to delete this inspector?</h5>
              </div>
              <div class="form-group">
                <label class="font-weight-bold">Enter your password to confirm:</label>
                <input v-model="deletePassword" class="form-control form-control-sm" type="password"/>
                <small class="text-danger font-weight-bold" style="font-style: italic">Note: Once deleted, you can still restore the inspector.</small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm" v-if="deletePassword">Proceed</button>
              <button type="submit" class="btn btn-primary btn-sm" v-else disabled>Proceed</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { InspectorsService } from "@/services/InspectorsService";
import { InspectorsCompaniesService } from "@/services/InspectorsCompaniesService";
import Swal from 'sweetalert2';
import Table from "@/components/layouts/Table.vue";
import {AlertService} from "@/services/AlertService";
import {RevisionService} from "@/services/RevisionService";

export default {
  name: "SettingInspector",
  components: {Table},

  data() {
    return {
      inspectors: [],
      companies: [],
      loading: true,
      showCreateModal: false,
      showEditModal: false,
      showDeleteModal: false,
      editId: null,
      deleteId: null,
      deletePassword: null,
      form: {
        first_name: "",
        last_name: "",
        middle_name: "",
        extension: "",
        inspector_company_id: null,
      },
      currentPage: 1,
      perPage: 10,
      perPageOptions: [5, 10, 25, 50],
      searchQuery: "",
    };
  },
  computed: {
    filteredInspectors() {
      if (!this.searchQuery) return this.inspectors;
      const q = this.searchQuery.toLowerCase();
      return this.inspectors.filter((i) => {
        const first = (i.first_name || '').toLowerCase();
        const last  = (i.last_name || '').toLowerCase();
        const mid   = (i.middle_name || '').toLowerCase();
        const comp  = (i.company?.name || '').toLowerCase();
        return first.includes(q) || last.includes(q) || mid.includes(q) || comp.includes(q);
      });
    },
    paginatedInspectors() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredInspectors.slice(start, end);
    },
    totalPages() {
      const pages = Math.ceil(this.filteredInspectors.length / this.perPage);
      return Math.max(1, pages);
    },
  },

  methods:{
    showToast(icon, title) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    showAlert(icon, title, text = "", showCancel = false) {
      return Swal.fire({
        icon,
        title,
        text,
        showConfirmButton: true,
        confirmButtonColor: "#42b983",
        showCancelButton: showCancel,
        allowEscapeKey: false,
        allowOutsideClick: false,
        allowEnterKey: true,
        confirmButtonText: "OK",
      });
    },

    loadingModal() {
      Swal.fire({
        title: "Loading...",
        text: "Please wait",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },

    async fetchInspectors(id) {
      this.loading = true;
      try {
        const response = await InspectorsService.getAll();
        this.inspectors = response.data;
        if(!id){
          this.showToast("success", "Inspectors loaded successfully!");
        }
      } catch (error) {
        console.error("Failed to load inspectors", error);
        this.showToast("error", "Failed to load inspectors!");
      } finally {
        this.loading = false;
      }
    },

    async fetchInspectorsCompanies() {
      try {
        const response = await InspectorsCompaniesService.getAll();
        this.companies = response.data;
      } catch (error) {
        console.error("Failed to load companies", error);
        this.showToast("error", "Failed to load companies");
      }
    },

    async createInspector() {
      try {
        if(!this.form.first_name){
          this.showAlert("error", "First name is required!");
        }
        else if(!this.form.last_name){
          this.showToast("error", "Last name is required!");
        }
        else if(!this.form.inspector_company_id){
          this.showToast("error", "Please select a company!");
        }
        else if(this.form.first_name.length < 2 || this.form.last_name.length < 2){
          this.showToast("error", "First and last name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to add this inspector?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            await InspectorsService.create(this.form);
            this.showToast("success", "Inspector created");
            this.showCreateModal = false;
            this.resetForm();
            this.fetchInspectors('1');
          } else {
            this.showToast("info", "Creation cancelled");
          }
        }
      } catch {
        this.showToast("error", "Failed to create");
      }
    },

    async updateInspector() {
      try {
        if(!this.form.first_name){
          this.showAlert("error", "First name is required!");
        }
        else if(!this.form.last_name){
          this.showAlert("error", "Last name is required!");
        }
        else if(this.form.first_name.length < 2 || this.form.last_name.length < 2){
          this.showAlert("error", "First and last name must have at least 2 characters!");
        }
        else{
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to update this inspector?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#42b983",
            confirmButtonText: "Yes, please proceed!",
            cancelButtonText: "No, cancel!",
          });

          if (result.isConfirmed) {
            this.loadingModal();
            await InspectorsService.update(this.editId, this.form);
            this.showAlert("success", "Inspector updated");
            this.showEditModal = false;
            this.resetForm();
            this.fetchInspectors('1');
          }
        }
      } catch {
        this.showToast("error", "Failed to update");
      }
    },

    async deleteInspector() {
      try {
        this.loadingModal();
        await InspectorsService.deleteWithPassword(this.deleteId, this.deletePassword);
        this.showToast("success", "Inspector deleted!");
        this.fetchInspectors(this.deleteId);

        this.showDeleteModal = false;
        this.deletePassword = '';
        this.deleteId = '';

        this.showAlert("success", "Inspector deleted successfully!");
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.showAlert("error", "Incorrect Password" ,"Please check if the password you entered is correct before submitting.");
        } else {
          AlertService.errorAlert('Failed to delete inspector', 'ERROR');
        }
      }
    },

    async restoreInspector(id) {
      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to restore this inspector?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#42b983",
          confirmButtonText: "Yes, please proceed!",
          cancelButtonText: "No, cancel!",
        });

        if (result.isConfirmed) {
          this.loadingModal();
          await InspectorsService.restore(id);
          this.showToast("success", "Inspector restored!");
          this.fetchInspectors(id);
        }
      } catch (error) {
        console.error("Failed to restore inspector", error);
        this.showToast("error", "Failed to restore inspector!");
      }
    },

    openCreateModal() {
      this.resetForm();
      this.showCreateModal = true;
    },

    cancelCreateModal(){
      this.showAlert('warning','Cancel Add Inspector', 'Are you sure you want to cancel? Any information you entered will not be saved.', true).then((result) => {
          if (result.isConfirmed) {
            this.showCreateModal = false;
            this.showAlert("error", "Add Inspector Cancelled!");
          }
      });
    },

    openEditModal(inspector) {
      this.form = {
        first_name: inspector.first_name,
        last_name: inspector.last_name,
        middle_name: inspector.middle_name,
        extension: inspector.extension,
        inspector_company_id: inspector.inspector_company_id,
      };
      this.editId = inspector.id;
      this.showEditModal = true;
    },

    cancelUpdateModal(){
      this.showAlert('warning','Cancel Update Inspector', 'Are you sure you want to cancel? Any changes you made will not be saved.', true).then((result) => {
        if (result.isConfirmed) {
          this.showEditModal = false;
          this.showAlert("error", "Update Inspector Cancelled!");
        }
      });
    },

    openDeleteModal(data) {
      this.showDeleteModal = true;
      this.deleteId = data;
      this.deletePassword = null;
    },

    cancelDeleteModal(){
      this.showAlert('warning','Cancel Delete Inspector', 'Are you sure you want to cancel? Any changes you made will not be saved.', true).then((result) => {
        if (result.isConfirmed) {
          this.showDeleteModal = false;
          this.deleteId = null;
          this.deletePassword = null;
          this.showAlert("error", "Delete Inspector Cancelled!");
        }
      });
    },

    resetForm() {
      this.form = {
        first_name: "",
        last_name: "",
        middle_name: "",
        extension: "",
        inspector_company_id: null,
      };
      this.editId = null;
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    perPage() {
      this.currentPage = 1;
    },
    filteredInspectors() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
  },

  async created() {
    await this.fetchInspectors();
    await this.fetchInspectorsCompanies();
  },
};
</script>

<style scoped>
.status-active {
  background-color: #10B981 !important;
}
.status-inactive {
  background-color: #EF4444;
}

.circle {
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50px;
}
</style>
